import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { register, load, getInstances } from '@shopify/theme-sections';
import * as a11y from '@shopify/theme-a11y';
import * as LocalCookie from '../utilities/local-storage-cookie';
import * as Layout from '../utilities/layout';
import * as Helper from '../utilities/helpers';
Avatar.theme = Avatar.theme || {};
Avatar.skup = Avatar.skup || {};
Avatar.theme.sections = Avatar.theme.sections || {};
var sectionName = 'email-modal';

Avatar.theme.sections.EmailModal = function EmailModal() {
  var selectors = {
    modalContent: '[data-email-modal-content]',
    modalForm: '[data-email-modal-form]',
    modalInput: '[data-email-modal-input-field]',
    modalSubmit: '[data-email-modal-submit]',
    modalSubmitContent: '[data-email-modal-submit-content]',
    modalSpinner: '[data-email-modal-spinner]',
    modalClose: '[data-email-modal-close]',
    modalSuccess: '[data-email-modal-success]',
    modalSuccessAr: '[data-email-modal-ar-success]',
    modalError: '[data-email-modal-error]',
    modalErrorAr: '[data-email-modal-ar-error]'
  };
  var classes = {
    opacityNone: 'tw-opacity-0',
    pointerEventsNone: 'tw-pointer-events-none',
    invisible: 'tw-invisible',
    hide: 'tw-hidden'
  };
  register(sectionName, {
    onLoad: function onLoad() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var container;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                container = _this.container;
                _this.modal = _this.container;
                _this.modalContent = container.querySelector(selectors.modalContent);
                _this.modalForm = container.querySelector(selectors.modalForm);
                _this.modalInputs = container.querySelectorAll(selectors.modalInput);
                _this.modalSubmit = container.querySelector(selectors.modalSubmit);
                _this.modalSubmitContent = container.querySelector(selectors.modalSubmitContent);
                _this.modalSpinner = container.querySelector(selectors.modalSpinner);
                _this.modalClose = container.querySelector(selectors.modalClose);
                _this.modalSuccess = container.querySelector(selectors.modalSuccess);
                _this.modalSuccessAr = container.querySelector(selectors.modalSuccessAr);
                _this.modalError = container.querySelector(selectors.modalError);
                _this.modalErrorAr = container.querySelector(selectors.modalErrorAr);
                _this.eventHandlers = {};
                _this.settings = {};
                _this.scrollPosition = 0;

                if (_this.modal) {
                  _this.getSettings();

                  _this.eventHandlers.handleWindowOut = _this.handleWindowOut.bind(_this);

                  if (!Shopify.designMode) {
                    document.addEventListener('mouseout', _this.eventHandlers.handleWindowOut);
                  }

                  _this.eventHandlers.handleMobileExitIntent = _this.handleMobileExitIntent.bind(_this);
                  document.body.addEventListener('touchmove', Helper.debounce(_this.eventHandlers.handleMobileExitIntent, 100), {
                    passive: true
                  });

                  if (_this.modalSuccess || _this.modalError) {
                    _this.checkFormStatus();
                  }

                  if (_this.modalSubmit) {
                    _this.eventHandlers.detectFormSubmit = _this.detectFormSubmit.bind(_this);

                    _this.modalSubmit.addEventListener('click', _this.eventHandlers.detectFormSubmit);
                  }

                  if (_this.settings.thirdParty) {
                    _this.eventHandlers.handleThirdPartySetup = _this.handleThirdPartySetup.bind(_this);

                    _this.modalForm.addEventListener('submit', _this.eventHandlers.handleThirdPartySetup);
                  }
                }

                if (_this.modalClose && !Shopify.designMode) {
                  _this.eventHandlers.handleCloseClick = _this.handleCloseClick.bind(_this);

                  _this.modalClose.addEventListener('click', _this.eventHandlers.handleCloseClick);

                  _this.eventHandlers.handleEscKeyup = _this.handleEscKeyup.bind(_this);

                  _this.container.addEventListener('keyup', _this.eventHandlers.handleEscKeyup);

                  _this.eventHandlers.handleClickOutsideModal = _this.handleClickOutsideModal.bind(_this);

                  _this.modal.addEventListener('click', _this.eventHandlers.handleClickOutsideModal);
                }

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getSettings: function getSettings() {
      this.settings = JSON.parse(this.container.getAttribute('data-section-settings'));
      return this.settings;
    },
    onSelect: function onSelect() {
      Avatar.skup.exitModal = true;
      var timer = setInterval(previewExitModal.bind(this), 250);

      function previewExitModal() {
        if (this.modal) {
          clearInterval(timer);
          this.openModal();
        }
      }
    },
    onDeselect: function onDeselect() {
      if (this.modal) {
        this.closeModal();
      }

      window.scrollTo(0, 0);
    },
    handleWindowOut: function handleWindowOut(evt) {
      if (!evt.toElement && !evt.relatedTarget) {
        this.openModal();
      }
    },
    handleMobileExitIntent: function handleMobileExitIntent() {
      var currentScroll = window.pageYOffset;

      if (currentScroll < this.scrollPosition) {
        this.openModal();
      }

      this.scrollPosition = currentScroll;
    },
    openModal: function openModal() {
      if (!Shopify.designMode && !this.modalSuccess && !this.modalError && LocalCookie.checkExpiration('email-modal', this.settings.cookieLength) && this.settings.testMode === false) {
        return;
      }

      this.modal.classList.remove(classes.opacityNone);
      this.modal.classList.remove(classes.pointerEventsNone);
      this.modal.classList.remove(classes.invisible);
      Layout.fadeInOverlay();
      Layout.scrollLock(0);
      a11y.trapFocus(this.container, {
        elementToFocus: this.modalContent
      });
      this.modalSuccess = null;
      this.modalError = null;
    },
    handleCloseClick: function handleCloseClick(evt) {
      evt.preventDefault();
      this.closeModal();
    },
    handleClickOutsideModal: function handleClickOutsideModal(evt) {
      var target = evt.target;

      if (!target.closest(selectors.modalContent)) {
        this.closeModal();
      }
    },
    handleEscKeyup: function handleEscKeyup(evt) {
      if (evt.keyCode === Avatar.theme.keyboardKeys.ESCAPE) {
        this.closeModal();
      }
    },
    closeModal: function closeModal() {
      var _this2 = this;

      this.modal.classList.add(classes.opacityNone);
      this.modal.classList.add(classes.pointerEventsNone);
      this.modal.addEventListener('transitionend', function () {
        _this2.modal.classList.add(classes.invisible);
      }, {
        once: true
      });
      Layout.fadeOutOverlay();
      Layout.scrollUnlock(0);
      this.container.removeEventListener('keyup', this.eventHandlers.handleEscKeyup);
      a11y.removeTrapFocus();
      a11y.forceFocus(document.body);
    },
    checkFormStatus: function checkFormStatus() {
      if (this.settings.thirdParty) {
        return;
      }

      var modalSubmit = window.sessionStorage.getItem('modal-submit');
      window.sessionStorage.setItem('modal-submit', false);

      if (modalSubmit !== 'true') {
        this.modalSuccess = null;
        this.modalError = null;
        return;
      }

      this.openModal();
      var otherFormStatuses = document.querySelectorAll('[data-form-status]');
      otherFormStatuses.forEach(function (statusMessage) {
        if (statusMessage.closest('[data-form-status-container]')) {
          statusMessage.closest('[data-form-status-container]').remove();
        }

        statusMessage.remove();
      });

      if (this.modalSuccess) {
        this.setStatusFocus(this.modalSuccess);
      }

      if (this.modalError) {
        this.setStatusFocus(this.modalError);
      }
    },
    detectFormSubmit: function detectFormSubmit() {
      window.sessionStorage.setItem('modal-submit', true);
    },
    setStatusFocus: function setStatusFocus(element) {
      element.setAttribute('tabindex', -1);
      element.focus();
      element.addEventListener('blur', function (evt) {
        evt.target.removeAttribute('tabindex');
      }, {
        once: true
      });
    },
    handleThirdPartySetup: function handleThirdPartySetup(evt) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var target, membersUrl, formData, res, jsonRes;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                evt.preventDefault();
                target = evt.target;
                membersUrl = 'https://members.smar7apps.com/api/email/integration';
                formData = new FormData(target);

                _this3.modalSubmitContent.classList.add(classes.hide);

                _this3.modalSubmitContent.parentElement.disabled = true;

                _this3.modalSpinner.classList.remove(classes.hide);

                _context2.next = 9;
                return fetch(membersUrl, {
                  method: 'POST',
                  body: formData
                });

              case 9:
                res = _context2.sent;
                _context2.next = 12;
                return res.json();

              case 12:
                jsonRes = _context2.sent;

                if (res.status === 200) {
                  _this3.showSuccessMessage();
                } else {
                  _this3.showErrorMessage(jsonRes);
                }

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    showSuccessMessage: function showSuccessMessage() {
      this.modalErrorAr.classList.add(classes.hide);
      this.modalSuccessAr.classList.remove(classes.hide);
      this.modalInputs.forEach(function (input) {
        return input.classList.add(classes.hide);
      });
      this.setStatusFocus(this.modalSuccessAr);
    },
    showErrorMessage: function showErrorMessage(res) {
      this.modalErrorAr.classList.remove(classes.hide);
      this.modalSubmitContent.classList.remove(classes.hide);
      this.modalSubmitContent.parentElement.disabled = false;
      this.modalSpinner.classList.add(classes.hide);
      this.modalErrorAr.textContent = res.error;
      this.setStatusFocus(this.modalErrorAr);
    },
    onUnload: function onUnload() {
      document.removeEventListener('mouseout', this.eventHandlers.handleWindowOut);
      document.body.removeEventListener('touchmove', this.eventHandlers.handleMobileExitIntent);
      this.modalClose.removeEventListener('click', this.eventHandlers.handleCloseClick);
      this.modal.removeEventListener('click', this.eventHandlers.handleClickOutsideModal);
      this.modalForm.removeEventListener('submit', this.eventHandlers.handleThirdPartySetup);
      this.modalSubmit.removeEventListener('click', this.eventHandlers.detectFormSubmit);
      Layout.fadeOutOverlay();
      Layout.scrollUnlock();
      Avatar.skup.exitModal = false;
    }
  });
  load(sectionName);
  var instance = getInstances(sectionName);
  return instance[0];
}();